module.exports = __webpack_public_path__ + "img/mxr-m148-micro-chorus.01babe4c.jpg";